module.exports = __webpack_public_path__ + "img/AdobeStock_441949482.0ba8c1eb.jpeg";